module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol.js
// module id = 1471
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16